import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme, { textStyles as ts } from '../../theme';
import Link from '../Link';

const Wrapper = styled.div`
  padding-top: ${theme('spacing.superMassive')};

  @media (max-width: ${theme('layout.narrowWidth')}) {
    padding-top: ${theme('spacing.large')};
  }

  @media (max-height: 450px) {
    padding-top: ${theme('spacing.large')};
  }
`;

const Title = styled.h1`
  ${ts.veryLargeTitle};
  padding-bottom: ${theme('spacing.huge')};

  @media (max-width: ${theme('layout.narrowWidth')}) {
    ${ts.largeTitle};
    padding-bottom: ${theme('spacing.large')};
  }

  @media (max-height: 450px) {
    ${ts.largeTitle};
    padding-bottom: ${theme('spacing.large')};
  }
`;
export const Subtitle = styled.h2`
  ${ts.body};
`;

export const Subtitle2 = styled.h2`
  ${ts.body};
  padding: ${theme('spacing.medium')} ${theme('spacing.veryLarge')} ${theme('spacing.medium')} ${theme('spacing.veryLarge')};
`;

const Heading = ({ title, subtitle }) => (
  <Wrapper>
    {title && <Title>{title}</Title>}
    {subtitle && (
      typeof subtitle === 'string' ? (
        <Subtitle dangerouslySetInnerHTML={{ __html: subtitle }} />
      ) : (
        <Subtitle>{subtitle}</Subtitle>
      )
    )}
  </Wrapper>
);

Heading.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

Heading.defaultProps = {
  subtitle: null,
};

export const BodyLink = styled(Link)`
  ${ts.bodyPlaceholder};
  cursor: pointer;
`;

export const BodyText = styled.h2`
  ${ts.bodyPlaceholder};
  text-align: center;
`;

export default Heading;
